import { api } from 'app/config/apiConfig';
import { Discount } from '../model/types';

export const updateDiscountApi = api.injectEndpoints({
  endpoints: (builder) => ({
    updateDiscount: builder.mutation<Discount, Partial<Discount>>({
      query: (discount: Discount) => ({
        url: `/discounts/${discount.discountId}`,
        method: 'PUT',
        body: discount,
      }),
      invalidatesTags: ['Discounts', 'Rent options'],
    }),
  }),
});

export const { useUpdateDiscountMutation } = updateDiscountApi;
